import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ensureAssignments } from '../utils/experiments';

/**
 * Loads this session's A/B test assignments (utils/experiments.js) once the
 * page is idle (mounted inside IdleMount), and again after a sign-in or
 * sign-out. Renders nothing; never blocks the first paint.
 */
const ExperimentsBoot = () => {
  const { token } = useAuth();
  useEffect(() => { ensureAssignments(token); }, [token]);
  return null;
};

export default ExperimentsBoot;
